export default "__VITE_ASSET__DeM5k_4C__"